module.exports = __webpack_public_path__ + "media/images/icons/ic-danger-81762415ec2c2c29ad50d717023a1250.svg";